import React, { Suspense, useEffect, useState } from 'react';
import SEO from '../components/seo';
import Header from '../components/common/Header';
import Breadcrumb from '../components/common/Breadcrumb';
import Footer from '../components/common/Footer';
import { useParams } from 'react-router-dom';
import TeamDetailsArea from '../components/TeamDetails/TeamDetailsArea';
import { getProductComponent } from '../components/ProductDetails';
import { useLanguage } from '../contexts/LanguageContext';

const toTitle = (slug) =>
  (slug || '')
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');

// Pretty titles for specific slugs
const prettyTitleMap = {
  'qc-control-qualite': 'Quality Control',
};

const ProductDetails = () => {
  const { slug } = useParams();
  const rawTitle = prettyTitleMap[slug] || toTitle(slug);
  const DetailComponent = getProductComponent(slug) || TeamDetailsArea;
  const { currentLanguage, translateContent } = useLanguage();
  const [breadcrumbLabel, setBreadcrumbLabel] = useState('Product');
  const [homeLabel, setHomeLabel] = useState('Home');
  const [subtitleLabel, setSubtitleLabel] = useState(rawTitle);

  useEffect(() => {
    const translate = async () => {
      try {
        const [tProduct, tHome, tSubtitle] = await Promise.all([
          translateContent('Product'),
          translateContent('Home'),
          translateContent(rawTitle),
        ]);
        setBreadcrumbLabel(tProduct || 'Product');
        setHomeLabel(tHome || 'Home');
        setSubtitleLabel(tSubtitle || rawTitle);
      } catch {
        setBreadcrumbLabel('Product');
        setHomeLabel('Home');
        setSubtitleLabel(rawTitle);
      }
    };
    translate();
  }, [currentLanguage, translateContent, rawTitle]);

  return (
    <>  
      <SEO pageTitle="Product Details" />
      <Header/>
      <Breadcrumb title={breadcrumbLabel} subtitle={subtitleLabel} homeLabel={homeLabel} />
      <Suspense fallback={<div style={{ padding: 24 }}>Loading product details…</div>}>
        <DetailComponent />
      </Suspense>
      <Footer/>
    </>
  );
};

export default ProductDetails;